import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMergeCatalogItemsMutation } from '../../../../redux/api/fymAPI';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { isSuccessfulResult } from '../../../../redux/api/utils/isSuccessfulResult';
import { useShowToast } from '../../../../redux/slices/toasts/hooks';
import { mergeErrorKind } from './mergeRules';
import { mergeMessages } from './mergeMessages';

/**
 * The merge call of the catalog (design catalog-merge a3, a5, a6). `merge` resolves with the row
 * that stays, or null when the call failed; `errorKind` says how the dialog shows the failure.
 */
export function useMergeSongs({ accountId }: { accountId: number }) {
  const intl = useIntl();
  const { showSuccess } = useShowToast();
  const [mergeItems, { isLoading, error, reset }] = useMergeCatalogItemsMutation();

  const merge = useCallback(
    async (keepUuid: string, fromTitle: string, fromItemUuid: string): Promise<CatalogItem | null> => {
      const result = await mergeItems({ accountId, keepUuid, fromItemUuid });
      if (!isSuccessfulResult(result)) {
        return null;
      }
      showSuccess(intl.formatMessage(mergeMessages.done, { from: fromTitle, title: result.data.item.title }));
      return result.data.item;
    },
    [accountId, intl, mergeItems, showSuccess]
  );

  return { merge, isLoading, error, reset, errorKind: error === undefined ? undefined : mergeErrorKind(error) };
}
